import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { buildUrlString } from '@!/Util'
import { purchaseStoreWithCoinApi, purchaseStoreWithCreditApi, purchaseStoreWithFreeApi } from '@!/Api/storeBookPurchase'

export const usePurchase = (previousPage) => {
  const [redirectUrl, setRedirectUrl] = useState(null)
  const [apiError, setApiError] = useState(null)

  const purchaseApi = (purchaseParams) => {
    if (purchaseParams.total_price === 0) return purchaseStoreWithFreeApi(purchaseParams)

    if (purchaseParams.payment_type === 'coin') {
      return purchaseStoreWithCoinApi(purchaseParams)
    } else if (purchaseParams.payment_type === 'credit') {
      return purchaseStoreWithCreditApi(purchaseParams)
    }

    throw new Error('INVALID_PAYMENT_TYPE')
  }

  const purchaseMutation = useMutation({
    mutationFn: (purchaseParams) => purchaseApi(purchaseParams),
    onSuccess: (data) => {
      setRedirectUrl(data.redirect_url)
    },
    onError: (error) => {
      let errorMessage = ''
      let redirectError = false

      if (error.data?.error) {
        switch (error.data.error) {
          case 'NOT_ENOUGH_POINT':
            errorMessage = 'ポイントが不足しています。'
            break
          case 'PURCHASED_BOOK':
            errorMessage = '既に購入済みです。'
            break
          case 'NOT_ENOUGH_COIN':
            errorMessage = 'コインが不足しています。'
            break
          case 'INVALID_COUPON_CODE':
          case 'COUPON_NOT_APPLIED':
          case 'UNAVAILABLE_COUPON':
            errorMessage = 'クーポンが無効のため決済に失敗しました。'
            break
          case 'USED_COUPON':
            errorMessage = 'このクーポンはすでに使用されています。決済に失敗しました。'
            break
          case 'EXPIRED_COUPON':
            errorMessage = 'このクーポンは期限切れです。決済に失敗しました。'
            break
          case 'NOT_REGISTERED':
            errorMessage = 'クレジットカードが登録されていません。'
            break
          case 'INVALID_CARD_INFO':
            errorMessage = 'クレジットカードでの決済に失敗しました。'
            break
          case 'FAILED_USE_POINTS':
          case 'FAILED_ADD_POINTS':
          case 'FAILED_USE_COINS':
            errorMessage = 'ポイントの還元に失敗しました。お問合せください。'
            redirectError = true
            break
          case 'OUTDATED_CONTENTS':
            if (previousPage === 'cartPage') {
              errorMessage = 'カート内の作品情報が更新されております。ご確認の上、再度購入の手続きをお願いします。'
            } else {
              errorMessage = '購入に失敗しました。再度購入を行ってください。'
            }
            redirectError = true
            break
          default:
            errorMessage = '購入に失敗しました。再度購入を行ってください。'
            redirectError = true
        }
      } else {
        errorMessage = '購入に失敗しました。再度購入を行ってください。'
        redirectError = true
      }

      if (redirectError) {
        setRedirectUrl(buildUrlString('/store/purchase/error', { error_message: errorMessage }))
      }

      if (error.status === 422) {
        setRedirectUrl('/unauthorized')
      }

      setApiError(errorMessage)
    },
  })

  return [purchaseMutation, redirectUrl, apiError]
}
